import { lazy } from "react";
import { Route } from "../../../navigations/navigationsinterface";
import VisitaxHome from "../pages/VisitaxHome/VisitaxHome";
export const principalpageroutes: Route[] = [
  {
    path: '/',
    to: '/',
    Component: VisitaxHome,
    name: 'Visitax Home'
  },
  {
    path: '/FAQS',
    to: '/FAQS',
    Component: lazy(() => import("../pages/FAQS/FAQ")),
    name: 'FAQS'
  },
  {
    path: '/Blog',
    to: '/Blog',
    Component: lazy(() => import("../pages/Blog/Blog")),
    name: 'Blog'
  },
  {
    path: '/Blog/:id',
    to: '/Blog',
    Component: lazy(() => import("../pages/Blog/Blog")),
    name: 'Blog Detail'
  },

];
